/**
 * The Campaigns list's own URL params. Before NPJB-899 the list lived at `/`, so a bookmark
 * like `/?status=campaign_active&clients=…` still means "the filtered Campaigns list".
 */
const CAMPAIGN_LIST_PARAMS = ['status', 'clients', 'search', 'mine'];

/** Whether a `/` query string is an old Campaigns-list link that should open `/campaigns`. */
export const isOldCampaignListLink = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return CAMPAIGN_LIST_PARAMS.some((key) => params.has(key));
};
